import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import intersect from "@alpinejs/intersect";
import focus from "@alpinejs/focus";

import {
  alpineDataPdpState,
  alpineDataKlaviyoNewsletter,
  alpineDataKlaviyoBackInStock,
  alpineDataBlogFilters,
} from "./data";
import { alpineDirectivePrice, alpineDirectiveCommas } from "./directives";
import {
  alpineStoreCart,
  alpineStoreMegaMenu,
  alpineStoreMerchant,
} from "./stores";
import { alpineMagics } from "./magics";

export const initAlpineScripts = () => {
  Alpine.plugin(collapse);
  Alpine.plugin(intersect);
  Alpine.plugin(focus);

  alpineStoreMerchant();
  alpineStoreMegaMenu();

  alpineDataKlaviyoNewsletter();
  alpineDirectivePrice();
  alpineDirectiveCommas();

  if (CART_TYPE === "custom") {
    alpineStoreCart();
  }

  if (TEMPLATE === "product") {
    alpineDataPdpState();
    alpineDataKlaviyoBackInStock();
  }

  if (TEMPLATE === "blog") {
    alpineDataBlogFilters();
  }

  alpineMagics();

  window.Alpine = Alpine;
  Alpine.start();
};
